module.exports = __webpack_public_path__ + "static/05-2b237254ec6b74066160a0a40a6abf3a.jpg";